export default {
  install(Vue, opts = {}) {
    Vue.prototype.$formatNumber = (value, format, withSymbol = false) => {
      if (isNaN(parseFloat(value)) || !isFinite(value)) {
        return ''
      }

      switch (format) {
        case 'i':
          return parseInt(value).toLocaleString(Vue.config.format.numberLocale, Vue.config.format.integerOptions)
        case 'f':
          return parseFloat(value).toLocaleString(Vue.config.format.numberLocale, Vue.config.format.floatOptions)
        case 'c':
          return withSymbol
            ? parseFloat(value).toLocaleString(Vue.config.format.numberLocale, Vue.config.format.currencyOptions)
            : parseFloat(value).toLocaleString(Vue.config.format.numberLocale, Vue.config.format.floatOptions)
        case 'p':
          return (parseFloat(value) / 100).toLocaleString(
            Vue.config.format.numberLocale,
            Vue.config.format.percentOptions,
          )
        default:
          return value
      }
    }
  },
}
